module.exports = __webpack_public_path__ + "img/alg4.888f3150.png";